// extracted by mini-css-extract-plugin
export default {"edit-report-popup":"EditReportPopup_edit-report-popup__ehJqh","popup-header":"EditReportPopup_popup-header__01-cQ"};